import { useState } from 'react';
import { url } from '../utils/config';
import Table from '../reusable_components/Table';
import { title } from '../utils/style';
import { FiEye } from 'react-icons/fi';
import fetchData from '../custom_functions/fetchData';
import { toast } from 'react-toastify';
import Modal from '../reusable_components/Modal';
import formatNumberToUs from '../custom_functions/formatNumberToUs';
import { formatDate } from "../helperFunctions/estimateCalculation"
import { formatTime } from "../helperFunctions/formatTime.js";

function CustomerList() {

    const [showModal, setShowModal] = useState(false);
    const [workOrder, setWorkOrder] = useState([]);

   
    const handleEyeClick = (customerId) => {
        setShowModal(true);
        fetchData(`${url}/work_orders/${customerId}`, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }, (data) => {
            setWorkOrder(data.data)
        })
    };

    const options = [
        {
            header: 'Customer Name',
            render: (data) => { return data.name },
            key: 'name'
        },
        {
            header: 'Phone No.',
            key: 'phone',
            placeHolder: '+1 1234567890'
        },
        {
            header: 'Email',
            key: 'email',
        },
        {
            header: 'Work Orders',
            render: (data) => <FiEye className='text-blue-600 cursor-pointer ml-4' onClick={() => handleEyeClick(data.id)} />,
        }
    ]

    const excludeFilter = ['Work Orders']

    return (
        <div className="p-4">
            <div className={`${title} mb-4`}>Individual Customer</div>
            <Table
                options={options}
                url={url + '/customers'}
                pagination
                noButton
                excludeFilter={excludeFilter}
            />
            {showModal && (
                <Modal
                    setShowModal={setShowModal}
                    component={() => (
                        <div className='text-sm m-2 max-h-100 overflow-y-auto'>
                            {workOrder.length > 0 ?
                                workOrder.map((order, index) => (
                                    <div
                                        key={order.id || index}
                                        className="border rounded-md p-4 shadow-sm bg-gray-50"
                                    >
                                        <h2 className="font-semibold mb-2 text-center">Work Order #{order.id}</h2>

                                        <div className="text-sm font-medium">
                                            <div >Total Tax:   <span className='font-semibold'> ${formatNumberToUs(order.tax || 0)} </span></div>
                                            <div >Total Cost: <span className='font-semibold'> ${formatNumberToUs(order.totalCostFinal || 0)}</span></div>
                                            <div >Estimated Completion Date & Time:  <span className='font-semibold'> {formatDate(order.estimatedDate)} {formatTime(order.estimatedTime)}</span></div>
                                        </div>

                                        {/* Services */}
                                        {order.serviceList && (
                                            <div className="mt-4">
                                                <p className="font-semibold border-b pb-1">Service List</p>
                                                <ul className="list-disc list-inside text-sm">
                                                    {JSON.parse(order.serviceList).data.map((s, i) => (
                                                        <li key={i}>
                                                            {s.name}{s.cost && `- $${formatNumberToUs(s.cost)}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* Materials */}
                                        {order.materialList && (
                                            <div className="mt-4">
                                                <p className="font-semibold border-b pb-1">Material List</p>
                                                <ul className="list-disc list-inside text-sm">
                                                    {JSON.parse(order.materialList).data.map((m, i) => (
                                                        <li key={i}>
                                                            {m.name}{m.cost && `- $${formatNumberToUs(m.cost)}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* Bundles */}
                                        {order.bundleList && (
                                            <div className="mt-4">
                                                <p className="font-semibold border-b pb-1">Bundle List</p>
                                                <ul className="list-disc list-inside text-sm">
                                                    {JSON.parse(order.bundleList).data.map((b, i) => (
                                                        <li key={i}>
                                                            {b.name} {b.cost && `- $${formatNumberToUs(b.cost)}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        {/* other */}
                                        {order.otherList && (
                                            <div className="mt-4">
                                                <p className="font-semibold border-b pb-1">Other List</p>
                                                <ul className="list-disc list-inside text-sm">
                                                    {JSON.parse(order.otherList).data.map((b, i) => (
                                                        <li key={i}>
                                                            {b.name} {b.cost && `- $${formatNumberToUs(b.cost)}`}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                )) :
                                <p className='m-8 text-center'> No WOrk Order Found</p>
                            }
                        </div>
                    )}
                />
            )}

        </div>
    )

}
export default CustomerList;